export default __webpack_public_path__ + "static/media/PNG.036e7cf5.svg";